import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ParadigmaModal from "../../../components/ParadigmaModal/ParadigmaModal.js"
import api from "../../../api";

import { Label, FormFeedback } from 'reactstrap';

import ParadigmaAsyncSeeker from "../../../components/ParadigmaAsyncSeeker/ParadigmaAsyncSeeker.js"
import ParadigmaLabeledInput from "../../../components/ParadigmaLabeledInput/ParadigmaLabeledInput.js"

class Autorizar extends Component {
    constructor(props) {
        super(props);
        this.state = {
            solicitud: null,
        };
    }

    static propTypes = {
        onSubmit: PropTypes.func.isRequired,
        id: PropTypes.func.isRequired,
    }

    setSelects(data) {
        this.setState({
            solicitud: data.solicitud_id,
            proyecto_codigo: data.codigo,
        });
    }

    render() {
        return (
            <ParadigmaModal
                getUrl={api.proyectos.cargadatos.autorizar}
                postUrl={api.proyectos.cargadatos.autorizar}
                onSubmit={() => this.props.onSubmit()}
                id={this.props.id}
                successMessage={"La Certificación ha sido autorizada para ser descargada por el personal."}
                missingIdMessage={"Debe seleccionar una fila."}
                notAllowedMessage={"El Certificado ya ha sido autorizado."}
                title={"Autorizar descarga de la certificación"}
                buttonTitle={"Autorizar descarga de la certificación"}
                buttonIcon={"fa fa-check fa-lg"}

                saveButton={true}
                buttonClass={"btn-success btn-next"}
                closeButton={true}
                className={"ui-modal-dialog ui-modal-md"}
                onGotData={(data) => this.setSelects(data)}>

                <div className="ui-form">
                    <section className="ui-section-block">
                        <p className="ui-section-label">Datos de la certificación</p>
                        <div className="ui-row-1">
                            <div className="ui-field">
                                <Label>Nº Presupuesto</Label>
                                <ParadigmaAsyncSeeker pkField={"codigo"} nombreField={"cod"} fieldName={""}
                                    url={api.proyectos.solicitudes.selectcodigo} value={this.state.proyecto_codigo} disabled={true} />
                                <FormFeedback />
                            </div>
                        </div>
                        <div className="ui-row-1">
                            <div className="ui-field">
                                <Label>Proyecto</Label>
                                <ParadigmaAsyncSeeker fieldName={"solicitud_id"} url={api.proyectos.solicitudes.select}
                                    value={this.state.solicitud} disabled={true} />
                                <FormFeedback />
                            </div>
                        </div>
                    </section>
                </div>
            </ParadigmaModal>
        );
    }
}

export default Autorizar;



// WEBPACK FOOTER //
// ./src/views/Proyectos/Procedimiento5/Autorizar.js